import React, { useState } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { setUserData } from '../redux/slices/userSlice';
import { useUser } from '../hooks/useUser';

const Account: React.FC = () => {
  const dispatch = useAppDispatch();
  const { userKey: currentKey, userToken: currentUserToken, companyKey: currentCompanyKey } = useUser();

  // Local state for form inputs
  const [userKey, setUserKey] = useState(currentKey || null);
  const [userToken, setUserToken] = useState(currentUserToken || '');
  const [companyKey, setCompanyKey] = useState(currentCompanyKey || null);

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Dispatch action to update user Credentials
    dispatch(setUserData({ userKey: Number(userKey), userToken: userToken, companyKey: companyKey}));

    // Store in localStorage
    localStorage.setItem('userCredentials', JSON.stringify({ userKey: userKey, userToken: userToken, companyKey: companyKey }));

    alert('User Credentials updated!');
  };

  const handleClearStorage = () => {
    localStorage.removeItem('userCredentials');
    alert('Local User Credentials cleared!');
  };

  return (
    <div style={{ backgroundColor: '#f6f6f6', color: '#464646', padding: '20px', margin: 'auto', width: '100vw', height: '100vh' }}>
      <span>Current User Key: {currentKey}</span>
      <span>Current Token: {currentUserToken}</span>
      <h2>Account Settings</h2>
      <form onSubmit={handleSubmit}>
        <div className="my-6">
          <label htmlFor="userKey">User Key:</label>
          <input
            type="number"
            id="userKey"
            value={userKey || ''}
            onChange={(e) => setUserKey(parseInt(e.target.value) || null)}
            style={{ width: '100%', padding: '8px', marginTop: '5px', borderRadius: '12px', backgroundColor: '#ebebeb' }}
            required
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="userToken">User token:</label>
          <input
            type="password"
            id="userToken"
            value={userToken}
            onChange={(e) => setUserToken(e.target.value)}
            style={{ width: '100%', padding: '8px', marginTop: '5px', borderRadius: '12px', backgroundColor: '#ebebeb' }}
            required
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="companyKey">Company Number:</label>
          <input
            type="number"
            id="companyKey"
            value={companyKey || ""}
            onChange={(e) => setCompanyKey(parseInt(e.target.value) || null)}
            style={{ width: '100%', padding: '8px', marginTop: '5px', borderRadius: '12px', backgroundColor: '#ebebeb' }}
            required
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary mb-3 md:mr-3"
        >
          Update
        </button>
        <button
          type="button"
          onClick={handleClearStorage}
          className="btn btn-primary mb-3"
        >
          Clear Local Storage
        </button>
      </form>
    </div>
  );
};

export default Account;
